import { useSchematicPlan } from "../../hooks/schematic-plan.hooks";
import { formatFileSize } from "./schematicFileRules";

type Props = {
  /** Database id of the application. */
  applicationId: number | undefined;
  className?: string;
};

/**
 * "Schematic Plan" section with View and Download for the uploaded file,
 * for the application details screens (Admin, L1, L2, L3 and the
 * applicant). It shows nothing while the certificate uses the drawing, and
 * nothing for the applicant until the application is Completed (the server
 * leaves the file out until then).
 */
export function SchematicPlanFileRow({ applicationId, className = "" }: Props) {
  const { data: plan } = useSchematicPlan(applicationId);
  const file = plan?.planType === "file" ? plan.file : null;
  if (!file) return null;

  return (
    <div className={`border rounded-lg p-4 bg-white ${className}`}>
      <h3 className="text-[#423F3F] font-bold text-lg mb-2">Schematic Plan</h3>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold text-[#423F3F] break-all">{file.name}</p>
          <p className="text-sm text-gray-500">
            Uploaded {file.fileType === "pdf" ? "PDF" : "image"}
            {file.size ? ` · ${formatFileSize(file.size)}` : ""}
          </p>
        </div>
        <div className="flex gap-2">
          <a
            href={file.url}
            target="_blank"
            rel="noreferrer"
            className="border border-primary text-primary px-4 py-1 rounded-full text-sm font-semibold"
          >
            View
          </a>
          <a
            href={file.url}
            download={file.name}
            target="_blank"
            rel="noreferrer"
            className="bg-primary text-white px-4 py-1 rounded-full text-sm font-semibold"
          >
            Download
          </a>
        </div>
      </div>
    </div>
  );
}
